import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtMoney, fmtDate } from "@/lib/helpers";
import { Package } from "lucide-react";

export default function OrdersList() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)).catch(() => {}); }, []);
  const counterpartyLabel = user.role === "buyer" ? "Supplier" : "Buyer";

  return (
    <div className="p-6 md:p-8 max-w-7xl">
      <div className="label-tech text-muted-foreground mb-1">Order management</div>
      <h1 className="text-3xl font-bold tracking-tight">{user.role === "supplier" ? "My orders" : "Orders"}</h1>

      <div className="mt-6 border border-border rounded-sm overflow-hidden bg-card">
        <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 border-b border-border label-tech text-muted-foreground bg-secondary/50">
          <div className="col-span-4">Part</div>
          <div className="col-span-3">{counterpartyLabel}</div>
          <div className="col-span-2 text-right">Value</div>
          <div className="col-span-1">Date</div>
          <div className="col-span-2 text-right">Status</div>
        </div>
        {orders.length === 0 && (
          <div className="px-5 py-12 text-center">
            <Package className="h-8 w-8 text-muted-foreground mx-auto" />
            <p className="mt-3 text-sm text-muted-foreground">No orders yet.</p>
          </div>
        )}
        {orders.map((o) => (
          <Link key={o.id} to={`/orders/${o.id}`} data-testid={`order-row-${o.id}`} className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 px-5 py-4 border-b border-border last:border-0 items-center hover:bg-secondary/50 transition-colors">
            <div className="col-span-2 md:col-span-4 min-w-0">
              <div className="font-medium truncate">{o.rfq_title}</div>
              <div className="text-xs font-mono text-muted-foreground">{o.process} · Qty {o.quantity}</div>
            </div>
            <div className="hidden md:block col-span-3 text-sm truncate">{user.role === "buyer" ? o.supplier_name : o.buyer_name}</div>
            <div className="hidden md:block col-span-2 text-right font-mono text-sm">{fmtMoney(o.total_price)}</div>
            <div className="hidden md:block col-span-1 text-xs text-muted-foreground">{fmtDate(o.created_at)}</div>
            <div className="col-span-2 flex justify-end"><StatusBadge status={o.status} /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
